module.exports = __webpack_public_path__ + "img/E1 Dot Box Choice Dn.90ba9173.png";